let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("edH9A")).then(() => parcelRequire('8auZY'));